/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Leveling_Faq_Rules_QInputs */



/**
* | output |
* | --- |
* | "How many XP rules do I get?" |
*
* @param {Products_Leveling_Faq_Rules_QInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_leveling_faq_rules_q = /** @type {((inputs?: Products_Leveling_Faq_Rules_QInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Leveling_Faq_Rules_QInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сколько правил XP доступно?")
	return /** @type {LocalizedString} */ ("How many XP rules do I get?")
});